import { useState } from "react";
import {
  Alert,
  Box,
  Checkbox,
  Collapse,
  IconButton,
  TextField,
} from "@mui/material";
import "./FormLogin.css";
import Logo from "../../assets/Logo/Logo";
import Boton from "../../components/Boton";
import { loginUser, saveToken } from "../../services/authService";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

export const FormLogin = () => {
  const [authFormData, setAuthFormData] = useState({
    email: "",
    password: "",
  });
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const onChange = (event) => {
    const { name, value } = event.target;
    setAuthFormData((prev) => ({ ...prev, [name]: value }));
    setErr("");
  };

  const handlerClick = async () => {
    setErr("");
    setOpen(false);
    setLoading(true);
    if (!authFormData.email || !authFormData.password) {
      setErr("Correo y contraseña son requeridos");
      setOpen(true);
      setLoading(false);
      return;
    }
    try {
      const data = await loginUser(authFormData.email, authFormData.password);
      saveToken(data);
      navigate("/dashboard", { replace: true });
    } catch (error) {
      setErr("Usuario o contraseña incorrectos o error de conexión");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handlerClick();
    }
  };

  return (
    <div className="for">
      <div className="logo-img">
        <Logo />
      </div>

      <div className="form-title three text-field-box form-box">
        <h1 className="form-title-sup">
          <span className="color-main">Ingresa a </span>
          <span className="color-tertiary">Devise</span>
        </h1>
        <div className="form-title-sub">Por favor ingresa tus datos</div>
      </div>

      <div className="two">
        <div className="text-field-box">
          <TextField
            onChange={onChange}
            value={authFormData.email}
            placeholder="Correo electrónico"
            className="textField form-box"
            name="email"
            onKeyPress={handleKeyPress}
            autoComplete="username"
          />
        </div>
        <div className="text-field-box">
          <TextField
            type={showPassword ? "text" : "password"}
            onChange={onChange}
            value={authFormData.password}
            name="password"
            placeholder="Contraseña"
            className="textField form-box"
            onKeyPress={handleKeyPress}
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <IconButton
                  onClick={() => setShowPassword((show) => !show)}
                  edge="end"
                  size="small"
                  tabIndex={-1}
                >
                  {showPassword ? <CloseIcon /> : <CloseIcon style={{ opacity: 0.3 }} />}
                </IconButton>
              ),
            }}
          />
        </div>
      </div>

      <Box sx={{ width: "100%" }}>
        <Collapse in={open || !!err}>
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setOpen(false);
                  setErr("");
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {err}
          </Alert>
        </Collapse>
      </Box>

      <div className="three text-field-box form-box">
        <div>
          <Checkbox id="chk" />
          <label htmlFor="chk">Recordarme</label>
        </div>
        <p className="forgotPassword">
          <Link className="link" to={"/reset-password"}>
            ¿Olvidaste tu contraseña?
          </Link>
        </p>
      </div>

      <div className="three text-field-box form-box">
        <Boton
          className="btn button-secondary form-box"
          label={loading ? "Iniciando sesión..." : "Continuar"}
          variant="contained"
          handlerClick={handlerClick}
          disabled={loading}
        >
          {loading ? "Iniciando sesión..." : "Continuar"}
        </Boton>
      </div>

      <div className="three text-field-box form-box form-footer">
        <span className="form-title-sub">¿No tienes una cuenta?</span>&nbsp;
        <span className="color-tertiary">
          <Link className="link" to="/register">
            Crea una cuenta aquí
          </Link>
        </span>
      </div>

      <div className="copy-rigth">
        <div className="footer-left">
          <div className="float-content">Copyright © 2026 Devise V 1.0</div>
        </div>
      </div>
    </div>
  );
};
